export const baseURL = '/api/v1/tiktok_ads_manager' as const;

export default {
  tiktokAds: baseURL,
  createAd: `${baseURL}/create_ad/` as const,
  createCampaign: `${baseURL}/create_campaign/` as const,
  campaigns: `${baseURL}/campaign_templates` as const,
  adsets: `${baseURL}/adgroup_templates` as const,
  ad_settings: `${baseURL}/ad_settings` as const,
  accounts: `${baseURL}/accounts` as const,
  flows: `${baseURL}/get_flows` as const,
  texts: `${baseURL}/get_texts` as const,
};